import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["keyname", "name", "rename"];
import { Input } from 'react-login-page';
import { LockIcon } from '../icons/lock';
import { jsx as _jsx } from "react/jsx-runtime";
export var Password = props => {
  var {
      keyname = 'password',
      name,
      rename
    } = props,
    elmProps = _objectWithoutPropertiesLoose(props, _excluded);
  var nameBase = name || rename || keyname;
  var key = keyname || name;
  if (!elmProps.children) {
    elmProps.children = LockIcon;
  }
  return /*#__PURE__*/_jsx(Input, _extends({
    type: "password",
    placeholder: "Password",
    autoComplete: "on"
  }, elmProps, {
    name: nameBase,
    keyname: key
  }));
};
Password.displayName = 'Login.Password';